import {
  GET_ORDER_CHAT_DATA_ADMIN,
  GET_EVENT_CHAT_DATA_ADMIN,
  GET_DINER_CHAT_DATA_ADMIN,
  GET_VENDOR_CHAT_DATA_ADMIN
} from "../../types";

const initialState = {
  diner: [],
  event: [],
  order: [],
  vendor: []
};



export default function (state = initialState, action) {
  switch (action.type) {
    case GET_DINER_CHAT_DATA_ADMIN:
      return {
        ...state,
        diner: action.payload,
      };
    case GET_EVENT_CHAT_DATA_ADMIN:
      return {
        ...state,
        event: action.payload,
      };
    case GET_ORDER_CHAT_DATA_ADMIN:
      return {
        ...state,
        order: action.payload,
      };
    case GET_VENDOR_CHAT_DATA_ADMIN:
      return {
        ...state,
        vendor: action.payload,
      };
    default:
      return state;
  }
}
